<ng-container *transloco="let t" class="container">
    <form [formGroup]="inputForm">
        <app-admin-modal-layout
                [title]="'race.management.competitors.confirm.registration.dialog.title'"
                [saveLabel]="'app.common.confirm'"
                (onSave)="onConfirmClick()"
                (onClose)="onDismissClick()"
        >
            <div class="row">
                <div class="col-12 pt-20-10">
                    <app-select
                            formControlName="registrationStatus"
                            [displaySelectionAsBadge]="true"
                            [items]="registrationStatuses"
                            labelKeyPrefix="app.common.registrationStatus."
                            [badgeClasses]="['red', 'green']"
                            label="app.common.registrationStatus">
                    </app-select>
                </div>
                <div class="col-12 pt-20-10">
                    <app-select
                            formControlName="amountStatus"
                            [displaySelectionAsBadge]="true"
                            [items]="items"
                            labelKeyPrefix="account.statements.amountStatus."
                            [badgeClasses]="itemBadgeClasses"
                            label="competitor.management.payment.status">
                    </app-select>
                </div>
                <div class="col-12 pt-20-10">
                    <app-textarea
                            id="note"
                            formControlName="note"
                            rows="5"
                            label="competitor.management.payment.comment">
                    </app-textarea>
                </div>
            </div>

        </app-admin-modal-layout>
    </form>
</ng-container>
